export const API_URL = 'https://api.barbermujica.com';

//export const API_URL = 'http://localhost:5000';